import React from 'react';
import clsx from 'clsx';
import { isPlatform } from '@ionic/react';

import s from './CardItem.module.scss';

export interface CardItemProps {
  children: React.ReactNode;
  onClick: (e: any) => void;
  flex?: boolean;
}

const CardItem: React.FC<CardItemProps> = ({ children, onClick, flex }) => {
  return (
    <div
      style={
        flex ? { flexFlow: 'column', display: 'flex', height: '100%' } : {}
      }
      onClick={onClick}
    >
      <div
        className={clsx(
          s.CardItem,
          isPlatform('desktop') ? s.CardItem__hover_animation : undefined,
          flex ? s.CardItem__flex : undefined
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default CardItem;
